export default __webpack_public_path__ + "static/media/ManufactureSite.bdd44430.png";